import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { useLang } from "../i18n";

export default function Faq() {
  const { data, t } = useLang();
  const { FAQS, SITE } = data;
  const p = t.faq;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Seo title={p.seo.title} description={p.seo.description} path="/faq" jsonLd={jsonLd} />
      <section className="max-w-3xl mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-20 md:pb-28">
        <Reveal>
          <p className="eyebrow mb-5">{p.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight text-ink">
            {p.h1}
          </h1>
          <p className="mt-8 text-base md:text-lg text-body leading-relaxed">
            {p.introPre}
            <a href={SITE.phoneHref} className="text-sage font-semibold hover:text-terra transition-colors duration-300">
              {SITE.phone}
            </a>
            {p.introPost}
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-12 border-t border-sand">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-sand">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="text-left font-serif text-lg md:text-xl text-ink hover:text-sage hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-body leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </section>
      <CTABand />
    </>
  );
}
